export const getPowerDistributions = state => state.power.powerDistributions;
